import React from 'react';
import ERMSectionHeader from './ERMSectionHeader';

export default function ERMTemplates() {
  return (
    <>
      <ERMSectionHeader title="Templates" backTo="/erm/projects" showHelp />
      <div className="mt-3 p-3">
        <h4>Templates</h4>
        <p className="text-muted">Coming soon.</p>
      </div>
    </>
  );
}
